export interface ManifestConfig {
  id: string;
  name: string;
  version: string;
  entryPoint: string;
  beemi: {
    sdkVersion: string;
    core: { required: boolean };
    streams?: { required: boolean };
    'multiplayer-p2p'?: { required: boolean };
    user?: { required: boolean };
    'app-bridge'?: { required: boolean };
  };
}

export function generateDefaultManifest(
  projectId: string, 
  sdkVersion: string = '2.1.3' // Default for backward compatibility
): ManifestConfig {
  return {
    id: `studio-${projectId}`,
    name: 'Studio Game',
    version: '1.0.0',
    entryPoint: 'index.html',
    beemi: {
      sdkVersion, // Use provided version
      core: { required: true },
      streams: { required: true },
      user: { required: true },
      'app-bridge': { required: true }
    }
  };
}

